import { createSelector } from 'reselect'
import { Map } from 'immutable'

import { selectRuntimes } from './selectRuntimes'

export const selectRuntimeOptions = createSelector([selectRuntimes], (runtimes) =>
  runtimes.map((runtime) => new Map({ label: runtime, value: runtime }))
)
